(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('med-report', {
            parent: 'entity',
            url: '/med-report?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.medReport.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/med-report/med-reports.html',
                    controller: 'MedReportController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('medReport');
                    $translatePartialLoader.addPart('status');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('med-report-detail', {
            parent: 'entity',
            url: '/med-report/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.medReport.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/med-report/med-report-detail.html',
                    controller: 'MedReportDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('medReport');
                    $translatePartialLoader.addPart('status');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'MedReport', function($stateParams, MedReport) {
                    return MedReport.get({id : $stateParams.id});
                }]
            }
        })
        .state('med-report.new', {
            parent: 'med-report',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-report/med-report-dialog.html',
                    controller: 'MedReportDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                fromDate: null,
                                toDate: null,
                                code: null,
                                checkDigit1: null,
                                checkDigit2: null,
                                isActive: null,
                                status: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('med-report', null, { reload: true });
                }, function() {
                    $state.go('med-report');
                });
            }]
        })
        .state('med-report.edit', {
            parent: 'med-report',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-report/med-report-dialog.html',
                    controller: 'MedReportDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MedReport', function(MedReport) {
                            return MedReport.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('med-report', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('med-report.delete', {
            parent: 'med-report',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-report/med-report-delete-dialog.html',
                    controller: 'MedReportDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MedReport', function(MedReport) {
                            return MedReport.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('med-report', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
